module.exports = __webpack_public_path__ + "static/media/1.f39ed14f.mp4";